// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mxk3ewcm9pRlud {
  display: block;
  flex-shrink: 0;
  align-self: flex-start;
  padding: var(--ds-space-0, 0) 6px;
}
@media print {
  .mxk3ewcm9pRlud {
    display: none;
  }
}
.Iw4JfvN1O0a3Ol {
  box-sizing: border-box;
  width: 272px;
  padding: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-300, 12px);
  background-color: var(--tr-background-list);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.hGzkT3SbVTFyCC {
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: var(--ds-border-radius-100, 3px);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  min-height: 20px;
  max-height: 256px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  overflow: hidden;
  border: none;
  border-radius: var(--ds-border-radius-100, 4px);
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-semibold, 600);
  resize: none;
  overflow-wrap: break-word;
  /* Focus State */
}
.hGzkT3SbVTFyCC:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.hGzkT3SbVTFyCC:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.hGzkT3SbVTFyCC:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.hGzkT3SbVTFyCC[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.hGzkT3SbVTFyCC.HU0j58m54vgguY {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.hGzkT3SbVTFyCC.HU0j58m54vgguY:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.hGzkT3SbVTFyCC.HU0j58m54vgguY:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.hGzkT3SbVTFyCC.Sl83A4fGwZJtjt {
  width: 100%;
}
.hGzkT3SbVTFyCC::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.hGzkT3SbVTFyCC:focus {
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.hGzkT3SbVTFyCC::placeholder {
  font-weight: var(--ds-font-weight-semibold, 600);
}
.O0qMz5OPdvJrpG {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-100, 4px);
  gap: var(--ds-space-050, 4px);
}
[data-testid='jira-datasource-modal'] fieldset {
  margin-bottom: var(--ds-space-0, 0);
  border: 0;
}
[data-testid='jira-datasource-modal'] input {
  margin-bottom: var(--ds-space-0, 0);
  box-shadow: none;
}
[data-testid='jira-datasource-modal'] input:focus {
  box-shadow: none;
}
[data-testid='jira-datasource-modal'] input[type='radio'] {
  display: none;
}
[data-testid='jira-datasource-modal'] label {
  margin-top: var(--ds-space-0, 0px);
  margin-bottom: var(--ds-space-0, 0px);
}
[data-testid*='jlol-basic-filter'] input, [data-testid*='jlol-basic-filter'] input:focus {
  box-shadow: none;
}
`, ""]);
// Exports
export var listComposerContainer = `mxk3ewcm9pRlud`;
export var listComposer = `Iw4JfvN1O0a3Ol`;
export var listNameTextarea = `hGzkT3SbVTFyCC`;
var _1 = `HU0j58m54vgguY`;
export { _1 as "input-error" };
export var full = `Sl83A4fGwZJtjt`;
export var listComposerSubmit = `O0qMz5OPdvJrpG`;
export default ___CSS_LOADER_EXPORT___;
